import React, { useState, useContext } from "react";
import { NavigationContext } from "navigation-react";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";

const DeleteUserRegister = () => {
  const { data, stateNavigator } = useContext(NavigationContext);
  const [loading, setLoading] = useState(false);

  if (loading) {
    return (
      <div className="loadingindicator">
        <p>Loading...</p>
      </div>
    );
  }

  const handleDelete = async () => {
    // e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(
        `/user/${data.userDetails[0]}?_format=json`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Basic ${btoa("salisu:abc@123@Q")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.ok) {
        setLoading(false);
        stateNavigator.navigate("userregister");
        console.log("User deleted successfully!");
      } else {
        setLoading(false);
        const error = await response.json();
        alert(`Error: ${JSON.stringify(error.message)}`);
        console.log("Error:", error);
      }
    } catch (error) {
      setLoading(false);
      console.log("Network Error:", error);
    }
  };

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="delete-patient-register">
          <div className="deleteBlock">
            <div className="deleteNcancleTxt">
              <p>Are you sure you want to delete</p>
              <span>{`${data.userDetails[1]}`} ?</span>
            </div>
            <div className="deleteNcancleAction">
              <button onClick={() => handleDelete()}>Yes</button>
              <button onClick={() => stateNavigator.navigate("userregister")}>
                No
              </button>
            </div>
          </div>
        </div>
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default DeleteUserRegister;
